import { useSystemUtilizationLazyQuery, useWorkloadsLazyQuery } from '@/graphql/codegen/generated/graphql';
import { useDashboardFilters } from './components/dashboard-filter-bar/dashboard-filter.provider';

export const dashboardDataGQL = <T extends 'useSystemUtilizationQuery' | 'useWorkloadsQuery'>(
  query: T,
): {
  useSystemUtilizationQuery: ReturnType<typeof useSystemUtilizationLazyQuery>;
  useWorkloadsQuery: ReturnType<typeof useWorkloadsLazyQuery>;
}[T] => {
  const gqlQuery = query === 'useSystemUtilizationQuery' ? useSystemUtilizationLazyQuery : useWorkloadsLazyQuery;
  const dashboardFilters = useDashboardFilters();

  const gqlData = gqlQuery(
    () => ({
      filter: {
        timeZone: dashboardFilters.timeZone,
        from: dashboardFilters.rangeDate.value.from.valueOf(),
        to: dashboardFilters.rangeDate.value.to.valueOf(),
        buildGroup: dashboardFilters.buildGroup.value,
        workloadType: dashboardFilters.workloadType.value || undefined,
        initiatorType: dashboardFilters.initiatorType.value || undefined,
      },
    }),
    {
      fetchPolicy: 'cache-and-network',
    },
  );
  return gqlData;
};
